import { inject, Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { AuthService } from "@app/auth.service";
import { environment } from "@environments/environment";
import { filter, first, map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ScopeGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.userInfo$.pipe(
      filter((userInfo) => !!userInfo.id),
      first(),
      map((userInfo) => {
        const isInternal = userInfo.institutionType === "SC_INTERNAL" || userInfo.institutionId === environment.testInstitutionId;
        const hasNoRights = !userInfo.rights || userInfo.rights.length === 0;
        if (!userInfo.scope && (isInternal || hasNoRights)) {
          return true;
        }
        return this.router.parseUrl("/");
      }),
    );
  }
}
